import { render } from "./crm-accounts.vue?vue&type=template&id=cdca314c&scoped=true"
import script from "./crm-accounts.vue?vue&type=script&lang=js"
export * from "./crm-accounts.vue?vue&type=script&lang=js"

import "./crm-accounts.vue?vue&type=style&index=0&id=cdca314c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdca314c"]])

export default __exports__